angular.module('gym.contacts').factory('MakeUpClasses', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('makeup_classes');
}]);
